export default __webpack_public_path__ + "static/work-lime-crime-desktop-829f5ce2a078bef3c755c70f0bccf99d.png";